import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab, MessageBoxType } from '../../constants/Enums';
import { PconLoginStore, PconLoginOrganization, PconLoginUser } from '../../stores/PconLoginStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { UIHelper } from '../../utils/UIHelper';
import { ClickButton } from '../ClickButton';
import { PconLoginActions } from '../../actions/PconLoginActions';
import { ArticleStore } from '../../stores/ArticleStore';
import { PCON_LOGIN_PROFILE_URL } from '../../constants/Api';
import { LongButton } from '../LongButton';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';

import utils = egr.wcf.utils;

interface PconLoginTabState {
    tokenExists: boolean;
    userName: string;
    organization: string | null;
    email: string;
    sceneWillBeLost: boolean;
}

export class PconLoginTab extends BaseHamburgerTab<PconLoginTabState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(PconLoginStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                {utils.string.isNullOrEmpty(this.state.email) ? null : <div className="sidebar-subheader">{this.state.email}</div>}
                {this.content()}
            </HamburgerContentWrapper>
        );
    }

    protected getLabel(): string {
        return this.state.userName;
    }

    protected logout = (): void => {
        if (this.state.sceneWillBeLost) {
            ViewSettingsActions.showMessage({
                wrap: false,
                element: (
                    <div className="dialog-page" onClick={ViewSettingsActions.closeMessage}>
                        <div className="dialog-page-resizer" onClick={UIHelper.stopEvent}>
                            <div className="dialog-page-header">{t('If you log out, your drawing will be closed.')}</div>
                            <ClickButton className="cancel-button" callback={ViewSettingsActions.closeMessage}>{t('Cancel')}</ClickButton>
                            <ClickButton className="submit-button" callback={this.onSubmitClick}>
                                {t('OK')}
                            </ClickButton>
                        </div>
                    </div>
                ),
                type: MessageBoxType.DEFAULT
            });
        } else {
            PconLoginActions.logout();
            this.back();
        }
    };

    protected onSubmitClick = (): void => {
        PconLoginActions.logout();
        this.back();
        ViewSettingsActions.closeMessage();
    };

    protected onChange = (): void => {
        const organization: PconLoginOrganization | null = PconLoginStore.getState().organization;
        const user: PconLoginUser | null = PconLoginStore.getState().user;
        this.setState({
            tokenExists: PconLoginStore.isLoggedIn(),
            userName: PconLoginStore.getUserName(),
            organization: organization != null ? organization.name : null,
            email: user != null ? user.email : '',
            sceneWillBeLost: ArticleStore.getState().articleCount > 0
        });
    };

    protected content = (): JSX.Element => {
        if (this.state.tokenExists && this.state.userName) {
            return (
                <div className="long-button-group">
                    <a className="long-button with-icon user-button" href={PCON_LOGIN_PROFILE_URL} target="_blank">{t('User Account')}</a>
                    {this.state.organization ? <LongButton className="with-icon company-button not-available">{this.state.organization}</LongButton> : null}
                    <LongButton className="with-icon logout-button" onClick={this.logout}>{t('Log out')}</LongButton>
                </div>
            );
        }
        return (
            <div className="long-button-group">
                <LongButton
                    className="with-icon user-button"
                    onClick={PconLoginActions.login}
                >
                    {t('Login')}
                </LongButton>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/PConLoginTab.tsx